import React, { useState, useEffect } from 'react';
import { MessageSquare, Mail, Calendar } from 'lucide-react';

interface ContactButtonProps {
  onClick: () => void;
  onCalendarClick: () => void;
  onCalClick: () => void;
  className?: string;
}

export default function ContactButton({ 
  onClick, 
  onCalendarClick, 
  onCalClick,
  className = ''
}: ContactButtonProps) {
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    // Add click handler to close menu when clicking outside
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as HTMLElement;
      if (!target.closest('.contact-menu')) {
        setIsMenuOpen(false);
      }
    };

    document.addEventListener('click', handleClickOutside);
    return () => document.removeEventListener('click', handleClickOutside);
  }, []);

  const handleMainButtonClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsMenuOpen(!isMenuOpen);
  };

  const handleContactClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsMenuOpen(false);
    onClick();
  };

  const handleCalClick = (e: React.MouseEvent) => {
    e.stopPropagation();
    setIsMenuOpen(false);
    onCalClick();
  };

  return (
    <div className={`fixed bottom-8 right-8 z-30 contact-menu ${className}`}>
      {/* Menu Items */}
      <div className={`flex flex-col items-center gap-4 mb-4 transition-all duration-300 ${
        isMenuOpen ? 'opacity-100 transform translate-y-0' : 'opacity-0 transform translate-y-10 pointer-events-none'
      }`}>
        {/* Cal.com Button */}
        <button
          onClick={handleCalClick}
          className="bg-[#F98B3D] text-white p-4 rounded-full shadow-lg hover:bg-[#e07a2c] transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#F98B3D]"
          aria-label="Schedule with Cal.com"
        >
          <Calendar className="h-6 w-6" />
        </button>

        {/* Email Contact Button */}
        <button
          onClick={handleContactClick}
          className="bg-[#F98B3D] text-white p-4 rounded-full shadow-lg hover:bg-[#e07a2c] transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#F98B3D]"
          aria-label="Contact Form"
        >
          <Mail className="h-6 w-6" />
        </button>
      </div>

      {/* Main Button */}
      <button
        onClick={handleMainButtonClick}
        className={`bg-[#F98B3D] text-white p-4 rounded-full shadow-lg hover:bg-[#e07a2c] transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#F98B3D] ${
          isMenuOpen ? 'rotate-45' : ''
        }`}
        aria-label="Toggle Contact Menu"
      >
        <MessageSquare className="h-6 w-6" />
      </button>
    </div>
  );
}